import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import type { IExecutionDashboard } from '../../interfaces/ui';
import '../../styles/executionCenter.css';

interface ExecutionResultsTabProps {
  data: IExecutionDashboard | null;
  loading: boolean;
  error: string | null;
  projectId?: string;
  onClose: () => void;
  onViewDetailedResults?: (projectId: string) => void;
}

export default function ExecutionResultsTab({
  data,
  loading,
  error,
  projectId,
  onClose,
  onViewDetailedResults,
}: ExecutionResultsTabProps) {
  if (loading) {
    return (
      <Box className="ec-tab-loading">
        <CircularProgress size={40} color="primary" />
        <Typography>Loading execution results...</Typography>
      </Box>
    );
  }

  if (error) return <Typography className="ec-tab-error">{error}</Typography>;

  if (!data) {
    return (
      <Box className="ec-results-pending">
        <Typography component="p">
          Execution results are not available yet.
        </Typography>
      </Box>
    );
  }

  const dashboardUrl = data.dashboardUrl.trim();

  return (
    <Box className="ec-tab-panel">
      <Box className="ec-analysis-complete-banner">
        <Box className="ec-analysis-complete-icon-box">
          <CheckCircleIcon />
        </Box>
        <Box className="ec-analysis-complete-content">
          <Typography component="p" className="ec-analysis-complete-subtitle">
            Test execution completed successfully.
          </Typography>
          <Typography
            component="p"
            className="ec-analysis-complete-description"
          >
            Detailed execution insights, screenshots, failed scenarios,
            recommendations, and execution evidence are available in the
            detailed results report.
          </Typography>
          <Box className="ec-analysis-banner-actions">
            <Button
              variant="outlined"
              color="primary"
              className="ec-btn-secondary"
              onClick={onClose}
            >
              Back to Projects
            </Button>
            <Button
              variant="contained"
              href={dashboardUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="ec-btn-primary"
              size="medium"
            >
              View Detailed Results
              <OpenInNewOutlinedIcon
                style={{ fontSize: 20, paddingLeft: '6px' }}
              />
            </Button>
            {/* <Button
              variant="contained"
              color="primary"
              className="ec-btn-primary"
              onClick={() => {
                if (projectId && onViewDetailedResults) {
                  window.open(data.dashboardUrl, '_blank');
                  onViewDetailedResults(projectId);
                }
              }}
            >
              View Detailed Results
            </Button> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
